import { render, staticRenderFns } from "./ResolutionsListPage.vue?vue&type=template&id=11a0990d&"
import script from "./ResolutionsListPage.vue?vue&type=script&lang=ts&"
export * from "./ResolutionsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports